const main = resolve => require(['./user/main.vue'], resolve);
const login = resolve => require(['./user/login.vue'], resolve);
const invite = resolve => require(['./user/invite.vue'], resolve);
const userRegister = resolve => require(['./user/register.vue'], resolve);
const reset = resolve => require(['./user/reset.vue'], resolve);
const dashboard = resolve => require(['../dashboard.vue'], resolve);
const UserInfo = resolve => require(['./modules/userInfo.vue'], resolve);
const about = resolve => require(['./about/about.vue'], resolve);
// 联系我们
const contactUs = resolve => require(['./serve/contactUs.vue'], resolve);
export default [{
        path: '/System/about',
        component: about
    }, {
        path: '/invite/:inviteCode',
        component: invite
    }, {
        path: '/login',
        component: login
    }, {
        path: '/User/Register',
        component: userRegister
    }, {
        path: '/Company/Register',
        component: userRegister
    }, {
        path: '/reset',
        component: reset
    }, {
        path: '/System/serve/contact',
        component: contactUs
    },
    // {
    //     name: 'feedback',
    //     path: '/System/feedback',
    //     components: {
    //         default: resolve => require(['./feedback/feedback.vue'], resolve)
    //     }
    // },
    {
        path: '/System/serve/guideline',
        components: {
            default: resolve => require(['./serve/guideline.vue'], resolve)
        }
    },
    {
        path: '/crm/user/display',
        components: {
            default: resolve => require(['./crm/user.vue'], resolve)
        }
    },
    {
        path:'/dinglogin',
        component:resolve=>require(['./dinglogin/login.vue'],resolve)
    },

    {
        path: '/dashboard',
        name: 'dashboard',
        component: dashboard,
        meta: {
            requiresAuth: true
        },
        children: [{
                path: '/System/User/:UserID/Security',
                name: 'UserSecurity',
                components: {
                    top: UserInfo,
                    default: resolve => require(['./user/security.vue'], resolve)
                }
            },
            {
                path: '/System/User/Main',
                name: 'UserMain',
                components: {
                    top: UserInfo,
                    default: main
                }
            },
            {
                path: '/System/Company/:CompanyID/ContactInfo',
                components: {

                    default: resolve => require(['./contact/contact.vue'], resolve)
                }
            },
            {
                path: '/System/User/:UserID/ContactInfo',
                components: {

                    default: resolve => require(['./contact/contact.vue'], resolve)
                }
            },
            {
                path: '/System/User/:UserID/InvoiceInfo',
                components: {
                    top: UserInfo,
                    default: resolve => require(['./invoice/invoice.vue'], resolve)
                }
            },
            {
                path: '/System/Company/:CompanyID/InvoiceInfo',
                components: {
                    top: UserInfo,
                    default: resolve => require(['./invoice/invoice.vue'], resolve)
                }
            },
            // {
            //     path: '/System/Company/serviceConfig',
            //     name: 'serviceConfig',
            //     components: {
            //         
            //         default: resolve => require(['./customer/serviceConfig.vue'], resolve)
            //     }
            // },

            {
                path: '/System/User/:UserID/Role/:RoleCode',
                name: 'UserRoleList',
                components: {
                    top: UserInfo,
                    default: resolve => require(['./role/roleList.vue'], resolve)
                }
            }, {
                path: '/System/User/:UserID/Role/:RoleCode/:RoleID',
                name: 'UserRoleDetails',
                components: {
                    top: UserInfo,
                    default: resolve => require(['./role/details.vue'], resolve)
                }
            }, {
                path: '/System/Company/:CompanyID/Role/:RoleCode',
                name: 'RoleList',
                components: {

                    default: resolve => require(['./role/roleList.vue'], resolve)
                }
            }, {
                path: '/System/Company/:CompanyID/Role/:RoleCode/:RoleID',
                name: 'RoleDetails',
                components: {

                    default: resolve => require(['./role/details.vue'], resolve)
                }
            },
            {
                path: '/System/Company/:CompanyID/Main',
                name: 'Main',
                components: {

                    default: resolve => require(['./company/main.vue'], resolve),
                }
            },
            // {
            //     path: '/System/Company/Service/Setting/:ServiceID',
            //     name: 'servicesetting',
            //     components: {
            //         
            //         default: resolve => require(['./service/servicesetting.vue'], resolve)
            //     }
            // },
            // {
            //     path: '/System/Company/:CompanyID/ServiceInfo',
            //     name: 'ServiceInfo',
            //     components: {
            //         
            //         default: resolve => require(['./service/ServiceInfo.vue'], resolve)
            //     }
            // },
            {
                path: '/System/Company/:CompanyID/CustomerLevel',
                name: 'customerlevel',
                components: {

                    default: resolve => require(['./customer/customerlevel.vue'], resolve)
                }
            },
            {
                path: '/System/Company/TradeLevelAdd',
                name: 'TradeLevelAdd',
                components: {

                    default: resolve => require(['./customer/tradeleveladd.vue'], resolve)
                }
            },
            {
                path: '/System/Company/TradeFlightServiceSetting',
                name: 'TradeFlightServiceSetting',
                components: {

                    default: resolve => require(['./customer/flightLevelSetting.vue'], resolve)
                }
            },
            {
                path: '/System/Company/TradeTourServiceSetting',
                name: 'TradeTourServiceSetting',
                components: {

                    default: resolve => require(['./customer/tradelevelset.vue'], resolve)
                }
            },
            // {
            //     path: '/System/Company/:CompanyID/AddServiceInfo',
            //     name: 'AddServiceInfo',
            //     components: {
            //         
            //         default: resolve => require(['./service/addServiceInfo.vue'], resolve)
            //     }
            // },
            // {
            //     path: '/System/Company/:CompanyID/addService',
            //     name: 'addService',
            //     components: {
            //         
            //         default: resolve => require(['./service/addService.vue'], resolve)
            //     }
            // }, {
            //     path: '/System/Company/:CompanyID/Subscribe',
            //     name: 'subscribeList',
            //     components: {
            //         
            //         default: resolve => require(['./service/subscribeList.vue'], resolve)
            //     }
            // }, {
            //     path: '/System/Company/subscribeService',
            //     name: 'subscribeService',
            //     components: {
            //         
            //         default: resolve => require(['./service/subscribeService.vue'], resolve)
            //     }
            // },
            {
                //差旅规则
                path: '/System/Company/:CompanyID/TripRule/:RuleID',
                name: 'TripRuleUpdate',
                components: {

                    default: resolve => require(['./TripRule/TripRuleUpdate.vue'], resolve)
                }
            },
            {
                //工作流程
                path: '/System/Company/:CompanyID/Flow/:FlowID',
                name: 'FlowUpdate',
                components: {

                    default: resolve => require(['./flow/FlowUpdate.vue'], resolve)
                }
            }, {
                path: '/System/Company/:CompanyID/Flow',
                name: 'FlowList',
                components: {

                    default: resolve => require(['./flow/FlowList.vue'], resolve)
                }
            },

            { //商旅配置
                path: '/Service/Btrip/:CompanyID/list',
                name: 'BusinessConfiguration',
                components: {

                    default: resolve => require(['./BusinessConfiguration/list.vue'], resolve)
                }
            },
            // {
            //     path: '/System/region',
            //     component: resolve => require(['./setup/region.vue'], resolve)
            // }, {
            //     path: '/System/Attractions',
            //     component: resolve => require(['./setup/Attractions.vue'], resolve)
            // }, {
            //     path: '/System/AttractionImg',
            //     component: resolve => require(['./setup/AttractionImg.vue'], resolve)
            // }, {
            //     path: '/system/setup/policysetup',
            //     component: resolve => require(['./setup/policysetup.vue'], resolve)
            // }, {
            //     path: '/system/setup/hotelStar',
            //     component: resolve => require(['./setup/hotelStar.vue'], resolve)
            // },
            {
                //服务费列表
                path: '/System/Charge/:CompanyID/ChargeList',
                name: 'ChargeList',
                components: {

                    default: resolve => require(['./Charge/ChargeList.vue'], resolve)
                }
            },
            { //服务费设置
                path: '/System/Charge/:CompanyID/ChargeUpdate',
                name: 'ChargeUpdate',
                components: {

                    default: resolve => require(['./Charge/ChargeUpdate.vue'], resolve)
                }
            }, { //违背原因
                path: '/System/ContraryReason/:CompanyID/ContraryUpdate',
                name: 'ContraryUpdate',
                components: {

                    default: resolve => require(['./BusinessConfiguration/BtripConfig/detail.vue'], resolve)
                }
            }, { //商旅目的
                path: '/System/TravePurpose/:CompanyID/TravePurposeUpdate',
                name: 'TravePurposeUpdate',
                components: {

                    default: resolve => require(['./BusinessConfiguration/BtripConfig/detail.vue'], resolve)
                }
            }, { //差旅审批
                path: '/System/TripFlow/:CompanyID/Detail',
                name: 'TripFlowUpdate',
                components: {

                    default: resolve => require(['./TripFlow/detail.vue'], resolve)
                }
            }, {
                path: '/System/ConfigInfo/:CompanyID/detail',
                name: 'ConfigInfoDetail',
                components: {

                    default: resolve => require(['./ConfigInfo/detail.vue'], resolve)
                }
            }, {
                path: '/System/message/:CompanyID/list',
                name: 'MessageList',
                components: {

                    default: resolve => require(['./message/list.vue'], resolve)
                }
            }, {
                path: '/System/message/:CompanyID/detail',
                name: 'MessageDetail',
                components: {

                    default: resolve => require(['./message/detail.vue'], resolve)
                }
            }, {
                path: '/System/approvalSet/:CompanyID/list',
                name: 'approvalSetList',
                components: {

                    default: resolve => require(['./approvalSet/list.vue'], resolve)
                }
            }, {
                path: '/System/approvalSet/detail',
                name: 'approvalSetDetail',
                components: {

                    default: resolve => require(['./approvalSet/detail.vue'], resolve)
                },
            }, {
                path: '/System/Confer/:ConferID/detail',
                name: 'ConferDetail',
                components: {

                    default: resolve => require(['./confer/detail.vue'], resolve)
                },
            },
            {
                path: '/System/WeChat/menu',
                name: 'WeChatMenu',
                components: {

                    default: resolve => require(['./WeChat/menu.vue'], resolve)
                },
            }, {
                path: '/System/ConfigInfo/configManagement',
                name: 'configManagement',
                components: {

                    default: resolve => require(['./ConfigInfo/configManagement.vue'], resolve)
                },
            },
            {
                path: '/System/ActivityManager/list',
                name: 'ActivityManagerList',
                components: {

                    default: resolve => require(['./ActivityManager/list.vue'], resolve)
                },
            },
            {
                path: '/System/ActivityManager/detail',
                name: 'ActivityManagerDetail',
                components: {

                    default: resolve => require(['./ActivityManager/detail.vue'], resolve)
                },
            },
            {
                path: '/System/ActivityManager/IntegralRecord',
                name: 'IntegralRecord',
                components: {

                    default: resolve => require(['./ActivityManager/IntegralRecord.vue'], resolve)
                },
            }, {
                path: '/System/ActivityManager/use',
                name: 'ActivityManagerUse',
                components: {

                    default: resolve => require(['./ActivityManager/use.vue'], resolve)
                },
            },
            {
                path: '/System/Employee/CustomersFree',
                name: 'CustomersFree',
                components: {

                    default: resolve => require(['./CustomersFree/CustomersFree.vue'], resolve)
                },
            },
            {
                path: '/system/scene/list',
                component : resolve=>require(['./WeChat/scenelist.vue'],resolve)
            }
            ,
            {
                path: '/system/scene/detail',
                component : resolve=>require(['./WeChat/sceneinfo.vue'],resolve)
            },
            {
                path: '/system/interfaceManage',
                component : resolve=>require(['./interfaceManage/interfaceManage.vue'],resolve)
            },
            {
                path: '/system/bill/exportlist',
                component : resolve=>require(['./export/list.vue'],resolve)
            },
            {
                path:'/system/dingding/detail',
                component:resolve=>require(['./dingding/detail.vue'],resolve)
            },
            {
                path:'/system/supply/list',
                component:resolve=>require(['./supply/list.vue'],resolve)
            },
            {
                path:'/system/cityCategory/list',
                component:resolve=>require(['./BusinessConfiguration/CityCategory/list.vue'],resolve)
            }
            // {
            //     path:'/system/workwechat/detail',
            //     component:resolve=>require(['./workwechat/detail.vue'],resolve)
            // },
        ]
    }
]



// WEBPACK FOOTER //
// ./src/views/system/router.js